<div class="fx--v fx--mt-lg">
  <div class="fx--h fx--ali-center fx--juc-space-between">
    <div class="fx--text__bold">Share with {{ title }}</div>
    <div class="fx--h">
      <a
        *ngIf="!(isEditing || selectedItems?.length > 0)"
        [class.disabled]="isAddDisabled"
        class="action-buttons fx--mr-sm"
        (click)="isAddDisabled ? $event.preventDefault() : add()"
        matTooltipPosition="above"
        [matTooltip]="addTooltip"
        matTooltipClass="tooltip-action-icon"
        ><mat-icon svgIcon="add-icon"></mat-icon> <span>Add</span></a
      >
      <div class="fx--h" *ngIf="isEditing">
        <a class="action-buttons fx--mr-sm" (click)="cancel()"
          ><mat-icon svgIcon="close-icon"></mat-icon> <span>Cancel</span></a
        >
        <a class="action-buttons" (click)="done()" [class.disabled]="disableSave"
          ><mat-icon svgIcon="save-icon"></mat-icon> <span>Save</span></a
        >
      </div>
      <div class="fx--h" *ngIf="selectedItems?.length">
        <a class="action-buttons fx--mr-sm" *ngIf="!(isEditing || selectedItems?.length > 1)" (click)="edit()"
          ><mat-icon svgIcon="edit-icon"></mat-icon> <span>Edit</span></a
        >
        <a class="action-buttons" *ngIf="!isEditing" (click)="deletePermission()"
          ><mat-icon svgIcon="trash-icon"></mat-icon> <span>Delete</span></a
        >
      </div>
    </div>
  </div>

  <div class="fx--h fx--mt-xs">
    <p-table
      #dataTable
      [columns]="headerColumns"
      [value]="tableRecords"
      [(selection)]="selectedItems"
      [selectionMode]="selectionMode"
      [paginator]="tableRecords?.length > 10"
      [rows]="5"
      [dataKey]="id"
      class="responsive-table"
      scrollable="tableRecords.length > 4"
      scrollHeight="225px"
      editMode="row"
      [sortField]="sortField"
      [sortOrder]="sortOrder"
      [ngClass]="{ 'responsive-table--not-editable': hideCheckbox }"
    >
      <ng-template pTemplate="header" let-columns>
        <tr>
          <ng-container *ngIf="!hideCheckbox">
            <th scope="col">
              <p-tableHeaderCheckbox [disabled]="isEditing"></p-tableHeaderCheckbox>
            </th>
          </ng-container>

          <th *ngFor="let col of columns" [pSortableColumn]="col.field">
            {{ col.header }}
            <p-sortIcon [field]="col.field"></p-sortIcon>
          </th>
        </tr>
      </ng-template>
      <ng-template
        pTemplate="body"
        let-tableRecord
        let-columns="columns"
        let-isEditing="isEditing"
        let-rowIndex="rowIndex"
      >
        <tr [pEditableRow]="tableRecord">
          <td class="fixed-width" *ngIf="!hideCheckbox">
            <p-tableCheckbox
              class="custom-checkbox"
              [value]="tableRecord"
              [disabled]="editingRowId !== null && editingRowId !== tableRecord.id"
            ></p-tableCheckbox>
          </td>
          <td *ngFor="let col of columns" class="flexible-width">
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input
                  matInput
                  name="{{ col.field }}"
                  *ngIf="col.inputType === 'Text'"
                  type="text"
                  [(ngModel)]="tableRecord[col.field]"
                  class="form-inputfield"
                  disabled="col.isDisabled"
                />

                <div *ngIf="col.inputType === 'autoComplete'" class="autocomplete-container">
                  <input
                    matInput
                    [formControl]="userFormControl"
                    name="{{ col.field }}"
                    type="text"
                    [(ngModel)]="tableRecord[col.field]"
                    [matAutocomplete]="auto"
                    class="form-inputfield autocomplete-input"
                  />
                  <mat-icon
                    class="autocomplete-icon clear-icon"
                    *ngIf="userFormControl.value"
                    (click)="clearUsernameInput()"
                  >
                    clear
                  </mat-icon>
                  <mat-icon class="autocomplete-icon search-icon">search</mat-icon>
                  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onOptionSelected($event)">
                    <mat-option
                      *ngFor="let user of filteredUsers$ | async"
                      [value]="usernameValue(user.firstName, user.lastName)"
                    >
                      <h5>{{ usernameValue(user.firstName, user.lastName) }}</h5>
                      <p>{{ user.emailAddress }}</p>
                    </mat-option>
                  </mat-autocomplete>
                </div>

                <p-select
                  *ngIf="col.inputType === 'dropdown'"
                  name="{{ col.field }}"
                  [(ngModel)]="tableRecord[col.field]"
                  (onChange)="onSelectionChange($event, col)"
                  [options]="col.values"
                  optionLabel="value"
                  [optionValue]="getDropdownOptionValue(col.field)"
                  appendTo="body"
                  [disabled]="col.isDisabled"
                  class="form-inputfield-dropdown"
                ></p-select>
              </ng-template>
              <ng-template pTemplate="output">
                {{ tableRecord | dataColumnFormatter: col }}
              </ng-template>
            </p-cellEditor>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage" let-columns>
        <tr>
          <td [attr.colspan]="(columns?.length || 0) + 1">No records found</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
